function playVideo(facade, fullscreen) {
    var videoId = facade.dataset.videoId;
    var platform = facade.dataset.platform;

    if (!videoId || !platform) return;

    var iframe = document.createElement('iframe');
    iframe.className = 'video__iframe border-0';
    iframe.title = 'Video player';
    iframe.allowFullscreen = true;

    if (platform === 'youtube') {
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    } else if (platform === 'vimeo') {
        iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    }

    if (facade.parentNode) {
        facade.parentNode.replaceChild(iframe, facade);
        iframe.focus();
    }

    if (fullscreen) {
        iframe.requestFullscreen?.();
    }
}

function initVideoFacades() {
    document.querySelectorAll('.video-facade').forEach(function (facade) {
        if (facade.dataset.initialized) return;
        facade.dataset.initialized = 'true';

        facade.querySelector('.video__fullscreen')?.addEventListener('click', function (e) {
            e.stopPropagation();
            playVideo(facade, true);
        });

        facade.addEventListener('click', function () { playVideo(facade); });
        facade.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                playVideo(facade);
            }
        });
    });
}

initVideoFacades();
